
























import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
import {VueConstructor} from 'vue';

@Component({
    inheritAttrs: false,
})
export default class CSearch extends Vue {
    @Prop({required: true}) value!: number | null;
    @Prop({default: true, type: Boolean}) showChangeState!: boolean;
    @Prop() initialValue!: number | undefined;
    @Prop() descriptionApi!: string;
    @Prop() searchDialog!: VueConstructor;
    @Prop({default: false, type: Boolean}) dense!: boolean;

    private localInitialValue: number | null = null;
    private loading: boolean = false;
    private text: string = '';

    get inputSearchClasses() {
        const classes: string[] = [];
        if (this.realInitialValue != this.value && this.showChangeState) classes.push('changed');
        return classes;
    }

    get realInitialValue() {
        return typeof this.initialValue != 'undefined' ? this.initialValue : this.localInitialValue;
    }

    @Watch('value', {immediate: true})
    onValueChange(value: number | null, oldValue: number | null) {
        if (value !== null && value !== oldValue) this.getDescription();
        else if (value === null) this.text = '';
    }

    created() {
        this.localInitialValue = this.value;
    }

    openSearchDialog() {
        (this.$refs.searchDialog as any).open();
    }

    clear() {
        this.$emit('input', null);
    }

    async getDescription() {
        const timerId = setTimeout(() => (this.loading = true), 100);
        try {
            const {data} = await this.$http.get(this.descriptionApi, {
                params: {
                    id: this.value,
                },
            });
            this.text = data.Name;
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }
}
